module.exports = __webpack_public_path__ + "static/media/ht.18b350ac.svg";